// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__25ztR","filesListContainer":"PosDisputesFiles_filesListContainer__1ib3F","filesButton":"PosDisputesFiles_filesButton__f4Pn5"};